/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
 =========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

import {
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import profileIcon from "assets/images/Profile-1.svg";
import profileIconDark from "assets/images/Profile.svg";
import MDBadge from "components/MDBadge";
import { useMaterialUIController } from "context";
import moment from "moment/moment";
import MDInput from "components/MDInput";
import { CloseRounded } from "@mui/icons-material";
import MDButton from "components/MDButton";
import {
  UpdateUserStatus,
  GetAllRoles,
  CreateUser,
  GetAllUsersWithSandbox,
  UpdateAPIStatus,
} from "api-services";
import products from "static-data/products";
import CustomPasswordField from "components/CustomPasswordField";
import "./users.css";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import { ShowSuccessMessage } from "helpers";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SendEmail from "./components/send_email_modal";
import RecentEmail from "./components/recent_email_modal";

const Author = ({ name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDBox lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

const Job = ({ title }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography
      display="block"
      variant="caption"
      color="text"
      fontWeight="medium"
    >
      {title}
    </MDTypography>
  </MDBox>
);
// Sandbox
const Products = ({ myAPI }) => {
  myAPI = myAPI.sort((a, b) => (a.name > b.name ? 1 : -1));
  return (
    <MDBox sx={{ display: "flex", flexDirection: "column" }}>
      {myAPI.map((item) => (
        <MDBadge
          key={item?.apiid}
          badgeContent={item?.name}
          sx={{ marginBottom: "5px" }}
          color={getProductBadgeColor(item?.apiid)}
          variant="gradient"
          size="sm"
        />
      ))}
    </MDBox>
  );
};

const getProductBadgeColor = (id) => {
  return "light";
};

const CustomCheckBox = ({ product, handleProductChange }) => {
  const [checked, setChecked] = useState(false);
  const handleChange = (id, value) => {
    handleProductChange(id, value);
    setChecked(value);
  };
  return (
    <MDBox sx={{ display: "flex", flexFlow: "wrap" }}>
      <Checkbox
        checked={checked}
        onChange={(e) => handleChange(product?.apiid, e.target.checked)}
      />
      {/* <Checkbox checked={checked} onChange={(e) => setChecked(!checked)} /> */}
      <MDTypography variant="subtitle2" mt={0.6}>
        {product?.name}
      </MDTypography>
    </MDBox>
  );
};

const CustomCheckBoxs = ({ product, handleProductChange }) => {
  const [checked, setChecked] = useState(true);
  const handleChange = (id, value) => {
    handleProductChange(id, value);
    setChecked(value);
  };
  return (
    <MDBox sx={{ display: "flex", flexFlow: "wrap" }}>
      <Checkbox
        checked={checked}
        onChange={(e) => handleChange(product?.apiid, e.target.checked)}
      />
      {/* <Checkbox checked={checked} onChange={(e) => setChecked(!checked)} /> */}
      <MDTypography variant="subtitle2" mt={0.6}>
        {product?.name}
      </MDTypography>
    </MDBox>
  );
};

function Users() {
  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  const fetchUsers = () => {
    GetAllUsersWithSandbox(
      dispatchData,
      successAction,
      errorAction,
      "",
      selectedTab,
      selectedUserStatusTab,
      selectedSandboxStatusTab
    );
  };

  const fetchRoles = () => {
    GetAllRoles(dispatchData, (res) => setRoles(res.data), errorAction);
  };

  const [rows, setRows] = useState([]);

  const [controller, dispatch] = useMaterialUIController();
  const { user_data } = useSelector((state) => state.authentication);
  const { darkMode } = controller;
  const [selectedItem, setSelectedItem] = useState();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  const { loading } = useSelector((state) => state.authentication);
  // Users
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState("");
  // Sandbox
  const [errorSandbox, setErrorSandbox] = useState("");
  const [successSandbox, setSuccessSandbox] = useState(false);
  const [failedSandbox, setFailedSandbox] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [updateSuccess, setUpdateSuccess] = useState("");

  //Add User States
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [selectedAPI, setSelectedAPI] = useState([]);
  const [roles, setRoles] = useState([]);

  // Update Status
  const [firmUserBelongsTo, setFirmUserBelongsTo] = useState("Default");
  const [boothId, setBoothId] = useState("Default");
  const [correspondentCode, setCorrespondentCode] = useState("Default");

  const [aoErrors, setAOErrors] = useState({});

  const [formErrors, setFormErrors] = useState({});

  const [selectedTab, setSelectedTab] = useState(1);

  const userFilterFetch = window.location.hash.substring(1);

  //Download
  const [downloadData, setDownloadData] = useState(null);

  const getUserStatus = (userFilterFetch) => {
    if (userFilterFetch === "") return "all";
    switch (userFilterFetch) {
      case "ALL":
        return "all";
      case "A":
        return "A";
      case "P":
        return "P";
      case "R":
        return "R";
      case "W":
        return "W";
      case "I":
        return "I";
      default:
        return "all";
    }
  };

  const [selectedUserStatusTab, setSelectedUserStatusTab] = useState(
    getUserStatus(userFilterFetch)
  );

  const SandboxFilterFetch = window.location.hash.substring(1);

  const getSandboxStatus = (sandboxFilterFetch) => {
    if (sandboxFilterFetch === "") return "all";
    switch (sandboxFilterFetch) {
      case "SALL":
        return "all";
      case "AA":
        return "A";
      case "PP":
        return "P";
      case "RR":
        return "R";
      case "WW":
        return "W";
      default:
        return "all";
    }
  };

  const [selectedSandboxStatusTab, setSelectedSandboxStatusTab] = useState(
    getSandboxStatus(SandboxFilterFetch)
  );
  const [dataLoading, setDataLoading] = useState(true);
  const [dataUpdating, setDataUpdating] = useState(true);
  const [statusValue, setStatusValue] = useState("");

  const [priviousStatus, setPriviousStatus] = useState("");
  const [priviousStatusUser, setPriviousStatusUser] = useState("");
  const dispatchData = useDispatch();

  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openRecentEmailModal, setOpenRecentEmailModal] = useState(false);

  //Send Email Modal
  const handleSendEmail = (item) => {
    setSelectedItem(item);
    setOpenEmailModal(true);
  };

  const handleCloseEmailModal = () => {
    setOpenEmailModal(false);
  };

  //Recent Email Modal
  const handleRecentEmail = (item) => {
    setSelectedItem(item);
    setOpenRecentEmailModal(true);
  };

  const handleCloseRecentEmailModal = () => {
    setOpenRecentEmailModal(false);
  };

  // setPriviousStatusUser(selectedItem?.userStatus);
  let bgColor = darkMode ? "#1a2035" : "#fff";

  const validateCheckBoxes = () => {
    let flag = false;
    selectedItem?.myAPI?.forEach((item) => {
      if (item.checked) {
        flag = true;
      }
    });

    return flag;
  };

  const validateAOBox = () => {
    let flag = false;
    selectedItem?.myAPI?.forEach((item) => {
      // console.log(item);
      if (item.apiid == 1 && item.checked) {
        flag = true;
      }
    });

    return flag;
  };

  // User
  const handleSubmit = () => {
    setError("");
    setSuccess(false);
    setFailed("");
    setDataUpdating(true);
    if (!selectedItem) {
      setError("Status cannot be empty!");
      setDataUpdating(false);
    } else if (priviousStatusUser == selectedItem?.userStatus) {
      setError("");
      setDataUpdating(false);
    } else {
      setDataUpdating(true);
      UpdateUserStatus(
        dispatchData,
        { userID: selectedItem?.userID, status: selectedItem?.userStatus },
        () => {
          GetAllUsersWithSandbox(
            dispatchData,
            successAction,
            errorAction,
            "",
            selectedTab,
            selectedUserStatusTab,
            selectedSandboxStatusTab
          );
          setSuccess(true);
          setTimeout(() => {
            selectedTab !== 1 && handleClose();
            setDataUpdating(false);
            handleClose();
            setError(false);
            setSuccess(false);
            setFailed("");
            setPriviousStatusUser(selectedItem?.userStatus);
          }, 3000);
        },
        (err) => {
          setFailed(err);
          setDataUpdating(false);
        },
        clearFields
      );
    }
  };

  // Get Sandbox Previous Status
  const prvStatusSandbox = priviousStatus?.myAPI
    ?.filter((i) => i.checked)
    ?.map((item) => {
      return item.status;
    });

  //Get Sandbox API Name
  const apiName = priviousStatus?.myAPI
    ?.filter((i) => i.checked)
    ?.map((item) => {
      if (item.status?.includes(statusValue)) {
        return item.name;
      }
    });

  const handleSubmitSandbox = () => {
    resetSandboxStates();

    if (!statusValue) {
      setErrorSandbox("Status cannot be empty!");
      setDataUpdating(false);
      return;
    }

    if (!validateCheckBoxes() && statusValue === "A") {
      setErrorSandbox("At least 1 product must be selected!");
      setDataUpdating(false);
      return;
    }

    if (validateAOBox() && !validateAccountOpeningUpdate()) {
      setDataUpdating(false);
      return;
    }

    if (prvStatusSandbox?.includes(statusValue)) {
      setErrorSandbox(getStatusErrorMessage(statusValue));
      setDataUpdating(false);
      return;
    }

    const productsData = getProductsData(selectedItem);
    const data = { products: productsData };

    UpdateAPIStatus(
      dispatchData,
      data,
      handleSuccess,
      handleError,
      clearFields
    );
  };

  const resetSandboxStates = () => {
    setErrorSandbox("");
    setSuccessSandbox(false);
    setFailedSandbox("");
    setDataUpdating(true);
  };

  const getStatusErrorMessage = (statusValue) => {
    const statusMessages = {
      A: "Approved",
      P: "Pending",
      R: "In Review",
      W: "Reject",
    };
    return `${apiName.toString().replace(/,/g, " - ")} - status is already ${
      statusMessages[statusValue] || "Unknown"
    }`;
  };

  const getProductsData = (selectedItem) => {
    return (selectedItem?.myAPI || [])
      .filter((i) => i.checked)
      .map((item) => ({
        identifier: item.identifier,
        status: item.newStatus,
        accessType: item?.access_type,
        firmUserBelongsTo: firmUserBelongsTo || "Default",
        boothId: boothId || "Default",
        correspondentCode: correspondentCode || "Default",
        office: boothId || "Default",
        clientId: "",
        name: "",
        value: "",
        booth: "",
        firm: "",
      }));
  };

  const handleSuccess = (res) => {
    GetAllUsersWithSandbox(
      dispatchData,
      successAction,
      errorAction,
      "",
      selectedTab,
      selectedUserStatusTab,
      selectedSandboxStatusTab
    );
    setUpdateSuccess(res.data);
    setTimeout(() => {
      resetSandboxStates();
      handleClose();
      setAOErrors({});
    }, 2000);
  };

  const handleError = (err) => {
    setShowErrorMessage(err);
    setDataUpdating(false);
  };

  // Create user
  const handleSubmitCreateUser = () => {
    setError("");
    setSuccess(false);
    setFailed("");

    if (validateCreateUser()) {
      let data = {
        FirstName: firstName,
        LastName: lastName,
        email: emailAddress,
        roleID: role,
        password: password,
      };

      CreateUser(
        dispatchData,
        data,
        () => {
          GetAllUsersWithSandbox(
            dispatchData,
            successAction,
            errorAction,
            "",
            selectedTab,
            selectedSandboxStatusTab,
            selectedUserStatusTab
          );
          setSuccess(true);
          clearFormFields();
          setTimeout(() => {
            setError("");
            setFailed("");
          }, 2000);
        },
        (err) => {
          setFailed(err);
        },
        clearFormFields
      );
    }
  };

  const handleTabChange = (tab) => {
    setDataLoading(true);
    setSelectedTab(tab);
    GetAllUsersWithSandbox(
      dispatchData,
      successAction,
      errorAction,
      "",
      tab,
      selectedUserStatusTab,
      selectedSandboxStatusTab
    );
  };

  const handleTabChangeStatus = (status) => {
    setDataLoading(true);
    setSelectedUserStatusTab(status);
    GetAllUsersWithSandbox(
      dispatchData,
      successAction,
      errorAction,
      "",
      selectedTab,
      status,
      selectedSandboxStatusTab
    );
  };

  const handleTabChangeSandboxStatus = (sandboxstatus) => {
    setDataLoading(true);
    setSelectedSandboxStatusTab(sandboxstatus);
    GetAllUsersWithSandbox(
      dispatchData,
      successAction,
      errorAction,
      "",
      selectedTab,
      selectedUserStatusTab,
      sandboxstatus
    );
  };

  // Sandbox
  const handleCheckboxChanged = (id, value) => {
    if (selectedItem) {
      let products = selectedItem.myAPI.map((item) => {
        if (item.apiid == id) {
          item.checked = value;
        }

        return item;
      });
      setSelectedItem({ ...selectedItem, myAPI: products });
      updateAPIStatuses(statusValue);
    }
  };

  const updateAPIStatuses = (status) => {
    if (selectedItem) {
      const products = selectedItem.myAPI.map((item) => {
        // Create a new object to avoid mutating the original item
        return {
          ...item,
          newStatus: item.checked ? status : item.status,
        };
      });

      setSelectedItem({ ...selectedItem, myAPI: products });
    }
  };

  const getColorByStatus = (status) => {
    switch (status) {
      case "I":
        return "primary";
      case "A":
        return "success";
      case "P":
        return "warning";
      case "R":
        return "info";
      default:
        return "error";
    }
  };

  // For Badge

  const getApiStatusDescription = (item) => {
    return item?.myAPI.length > 0 ? item.myAPI[0]?.apiStatusDes : "Pending";
  };

  const getApiStatus = (item) => {
    return item?.myAPI.length > 0 ? item.myAPI[0]?.status : "P";
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "A":
        return "success";
      case "P":
        return "warning";
      case "R":
        return "info";
      default:
        return "error";
    }
  };

  const validateCreateUser = () => {
    let tempErrors = {};
    let isValid = true;

    if (firstName.length <= 0) {
      tempErrors["firstname"] = true;
      isValid = false;
    }

    if (firstName.length > 50) {
      tempErrors["firstname_length"] = true;
      isValid = false;
    }
    if (lastName.length <= 0) {
      tempErrors["lastname"] = true;
      isValid = false;
    }

    if (lastName.length > 50) {
      tempErrors["lastname_length"] = true;
      isValid = false;
    }

    if (emailAddress.length <= 0) {
      tempErrors["emailAddress"] = true;
      isValid = false;
    }

    if (emailAddress.length > 150) {
      tempErrors["emailAddress_length"] = true;
      isValid = false;
    }

    if (role == "") {
      tempErrors["role"] = true;
      isValid = false;
    }

    if (password.length <= 0) {
      tempErrors["password"] = true;
      isValid = false;
    }

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^_+=!*()@%&]).{8,}$/;
    if (password.length > 0 && !regex.test(password)) {
      tempErrors["password_regex"] =
        "Password must be alphanumeric and at least 12 characters long, including one uppercase letter and a special character.";
      isValid = false;
    }

    setFormErrors({ ...tempErrors });
    return isValid;
  };

  // Validate Account opening API

  const validateAccountOpeningUpdate = () => {
    let tempErrors = {};
    let isValid = true;

    if (firmUserBelongsTo.length <= 0) {
      tempErrors["firmUserBelongsTo"] = true;
      isValid = false;
    }

    if (boothId.length <= 0) {
      tempErrors["boothId"] = true;
      isValid = false;
    }

    if (correspondentCode.length <= 0) {
      tempErrors["correspondentCode"] = true;
      isValid = false;
    }

    setAOErrors({ ...tempErrors });
    return isValid;
  };

  const columns = [
    { Header: "name", accessor: "name", align: "left" },
    { Header: "company name", accessor: "company_name", align: "left" },
    { Header: "company website", accessor: "company_website", align: "left" },
    { Header: "job role", accessor: "job_role", align: "left" },
    { Header: "user role", accessor: "user_role", align: "left" },
    { Header: "user status", accessor: "user_status", align: "left" },
    {
      Header: "product name",
      accessor: "product_name",
      width: "10%",
      align: "left",
    },
    {
      Header: "sandbox status",
      accessor: "product_status",
      width: "10%",
      align: "left",
    },
    {
      Header: "registered on",
      accessor: "registered_on",
      width: "9%",
      align: "left",
    },
    { Header: "action", accessor: "action", align: "center" },
  ];

  // Update status action

  function updateAPI(api) {
    return {
      ...api,
      checked: false,
      access_type: "Sandbox",
      newStatus: api.status,
    };
  }

  function updateItemAPIs(item) {
    item.myAPI = item.myAPI.map(updateAPI);
  }

  function updateStatusValues(item) {
    setStatusValue(item?.myAPI?.length > 0 ? item?.myAPI[0]?.status : "P");
    setPriviousStatusUser(item.userStatus);
    setSelectedItem(item);
  }

  function resetErrorStates() {
    setError("");
    setErrorSandbox("");
    setAOErrors({});
    clearSelectedItemFields("");
    setDataUpdating(false);
    setShowErrorMessage("");
    setUpdateSuccess("");
  }

  function handleItemClick(item) {
    updateItemAPIs(item);
    updateStatusValues(item);
    handleOpen();
    resetErrorStates();
    setPriviousStatus(item);
  }

  const getAPIStatus = (status) => {
    switch (status) {
      case "A":
        return "Approved";
      case "P":
        return "Pending";
      case "R":
        return "In Review";
      case "I":
        return "Suspended";
      case "W":
        return "Rejected";
      default:
        return "N/A";
    }
  };

  function getDataForDownload(userData) {
    setDownloadData(null);

    const csvData = userData.map((user) => {
      // Aggregate API names and their statuses
      const apiDetails = user.myAPI.map((api) => ({
        name: api.name ? api.name : "N/A",
        status: getAPIStatus(api.status), // Use getAPIStatus to get the status description
      }));

      // Create strings for API names and statuses
      const apiNames = apiDetails.map((api) => api.name).join(", ");
      const apiStatuses = apiDetails.map((api) => api.status).join(", ");
      return {
        Name: user.fullName,
        "Company Name": user.companyName ? user.companyName : "N/A",
        "Company Website": user.companyWebSite ? user.companyWebSite : "N/A",
        "Job Role": user.jobRole ? user.jobRole : "N/A",
        "User Role": user.role ? user.role : "N/A",
        "User Status": user.statusDesc ? user.statusDesc : "N/A",
        "Product Name": apiNames,
        "Sandbox Status": apiStatuses,
        "Registered On": moment(user.createdOn).format("MM/DD/yyyy"),
      };
    });

    setDownloadData(csvData);
  }

  const successAction = (res) => {
    setDataLoading(false);
    getDataForDownload(res.data);
    let allUsers = res.data.map((item) => {
      const fName = item.firstName;
      const lName =
        item.lastName !== null && item.lastName !== undefined
          ? item.lastName
          : "";
      const fullName = fName + " " + lName;
      return {
        name: (
          <Author
            image={darkMode ? profileIcon : profileIconDark}
            name={fullName}
            email={item.email}
          />
        ),
        company_name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {item.companyName ? item.companyName : "N/A"}
          </MDTypography>
        ),
        company_website: (
          <MDTypography
            component="a"
            href={item.companyWebSite ? "https://" + item.companyWebSite : ""}
            rel="noreferrer"
            target="_blank"
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {item.companyWebSite ? item.companyWebSite : "N/A"}
          </MDTypography>
        ),

        job_role: <Job title={item.jobRole ? item.jobRole : "N/A"} />,
        user_role: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={item.role}
              color="light"
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        user_status: (
          <MDBox sx={{ cursor: "pointer" }} ml={-1}>
            <MDBadge
              badgeContent={item.statusDesc}
              onClick={() => {
                setSelectedItem(item);
                // handleOpen();
              }}
              color={getColorByStatus(item.userStatus)}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        product_name: <Products myAPI={item?.myAPI} />,
        product_status: (
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDBadge
              badgeContent={getApiStatusDescription(item)}
              color={getStatusColor(getApiStatus(item))}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        registered_on: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(item.createdOn).format("MM/DD/yyyy")}
          </MDTypography>
        ),
        action: (
          <div className="action-gap">
            <Button
              sx={{
                textTransform: "uppercase",
                borderRadius: "4px",
                color: "white !important",
                fontSize: "11px",
              }}
              variant="contained"
              size="small"
              onClick={() => handleItemClick(item)}
            >
              Update Status
            </Button>
            <Tooltip
              title="Send Email"
              placement="bottom"
              className="custom-tooltip"
            >
              <Button
                sx={{
                  textTransform: "uppercase",
                  borderRadius: "4px",
                  color: "white !important",
                  fontSize: "11px",
                  background: "#359B51",
                }}
                variant="contained"
                size="small"
                iconOnly="true"
                onClick={() => handleSendEmail(item)}
              >
                <SendOutlinedIcon />
              </Button>
            </Tooltip>
            <Tooltip title="Recent Email" placement="bottom">
              <Button
                sx={{
                  textTransform: "uppercase",
                  borderRadius: "4px",
                  color: "white !important",
                  fontSize: "11px",
                  background: "transparent",
                }}
                variant="contained"
                size="small"
                iconOnly="true"
                onClick={() => handleRecentEmail(item)}
              >
                <RemoveRedEyeOutlinedIcon />
              </Button>
            </Tooltip>
          </div>
        ),
      };
    });

    setRows(allUsers);
  };

  const errorAction = () => {
    setDataLoading(false);
  };

  const clearFields = () => {
    setSelectedItem();
  };

  const clearSelectedItemFields = () => {
    // setFirmUserBelongsTo("");
    // setBoothId("");
    // setCorrespondentCode("");
    // setOffice("");
    // setClientId("");
    // setNameTrd("");
    // setValueTrd("");
    // setBoothTrd("");
    // setFirmFnd("");
  };

  const clearFormFields = () => {
    setFirstName("");
    setLastName("");
    setEmailAddress("");
    setPassword("");
    setRole("");
    setSelectedAPI([]);
  };

  const style = {
    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    noncutomer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "20%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    createModal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    createModalHeader: {
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      justifyContent: "space-between",
    },
  };

  const fName = selectedItem?.firstName;
  const lName =
    selectedItem?.lastName !== null && selectedItem?.lastName !== undefined
      ? selectedItem?.lastName
      : "";
  const fullName = fName + " " + lName;

  const renderMessage = (item) => {
    if (item.status === "Error") {
      return (
        <MDTypography
          color="error"
          variant="subtitle1"
          sx={{ fontSize: "12px", textAlign: "center" }}
          key={item.apiid}
        >
          {`${item.name} -  ${item.message} `}
        </MDTypography>
      );
    } else if (item.status === "Success") {
      return (
        <MDTypography
          color="success"
          variant="subtitle1"
          sx={{ fontSize: "12px", textAlign: "center" }}
        >
          {`${item.name} -  ${item.message} `}
        </MDTypography>
      );
    }
    return null; // Return null for any other status
  };

  const handleCSVDownload = () => {
    ShowSuccessMessage(dispatch, "Data exported successfully");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
        <MDBox mb={3} mt={2}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <Grid
                  container
                  spacing={6}
                  p={2}
                  sx={{ placeItems: "flex-end" }}
                >
                  <Grid item xs={12} xl={2} mt={2}>
                    {/* <MDBox>
                    <MDTypography textTransform="uppercase" sx={{ fontSize: '14px', fontWeight: 700 }}  mb={2} >Filters</MDTypography>
                    </MDBox> */}
                    <FormControl fullWidth sx={{ height: "50px" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        variant="outlined"
                        color="success"
                        className="inputbox mb-2"
                      >
                        User Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedUserStatusTab}
                        label="User Status"
                        onChange={(e) => {
                          handleTabChangeStatus(e.target.value);
                        }}
                        sx={{ height: "50px" }}
                      >
                        <MenuItem value={"all"}>All</MenuItem>
                        <MenuItem value={"A"}>Approved</MenuItem>
                        <MenuItem value={"P"}>Pending</MenuItem>
                        <MenuItem value={"R"}>In Review</MenuItem>
                        <MenuItem value={"W"}>Rejected</MenuItem>
                        <MenuItem value={"I"}>Suspended</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} xl={2}>
                    <FormControl fullWidth sx={{ height: "50px" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        variant="outlined"
                        color="success"
                        className="inputbox mb-2"
                      >
                        Sandbox Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedSandboxStatusTab}
                        label="Sandbox Status"
                        onChange={(e) => {
                          handleTabChangeSandboxStatus(e.target.value);
                        }}
                        sx={{ height: "50px" }}
                      >
                        <MenuItem value={"all"}>All</MenuItem>
                        <MenuItem value={"A"}>Approved</MenuItem>
                        <MenuItem value={"P"}>Pending</MenuItem>
                        <MenuItem value={"R"}>In Review</MenuItem>
                        <MenuItem value={"W"}>Rejected</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {user_data?.customer?.roleId === 4 && (
                    <Grid item xs={12} xl={2}>
                      <FormControl fullWidth sx={{ height: "50px" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          variant="outlined"
                          color="success"
                          className="inputbox mb-2"
                        >
                          User Roles
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedTab}
                          label="User Roles"
                          onChange={(e) => {
                            handleTabChange(e.target.value);
                          }}
                          sx={{ height: "50px" }}
                        >
                          <MenuItem value={0}>All</MenuItem>
                          <MenuItem value={1}>Customer</MenuItem>
                          {roles.map((item) => {
                            return (
                              <MenuItem value={item?.id} key={item?.id}>
                                {item?.description}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                  {user_data?.customer?.roleId === 2 ? (
                    <Grid
                      item
                      xs={12}
                      xl={6}
                      p={0}
                      className="padd-zero"
                    ></Grid>
                  ) : (
                    <Grid
                      item
                      xs={12}
                      xl={3}
                      p={0}
                      className="padd-zero"
                    ></Grid>
                  )}
                  {user_data?.customer?.roleId == 4 && (
                    <Grid
                      item
                      xs={12}
                      xl={3}
                      sx={{ justifyContent: "end", display: "flex" }}
                    >
                      <MDBox mr={1}>
                        {(() => {
                          if (
                            downloadData &&
                            ((Array.isArray(downloadData) &&
                              downloadData.length > 0) ||
                              typeof downloadData === "string")
                          ) {
                            return (
                              <CSVLink
                                data={downloadData}
                                className="white"
                                asyncOnClick={false}
                                filename={`Sandbox Requests.csv`}
                                onClick={handleCSVDownload}
                              >
                                <MDButton className="btn-spc" color="success">
                                  {!dataLoading ? (
                                    <span>Export</span>
                                  ) : (
                                    <CircularProgress color="white" size={22} />
                                  )}
                                </MDButton>
                              </CSVLink>
                            );
                          } else if (
                            Array.isArray(downloadData) &&
                            downloadData.length === 0
                          ) {
                            return <></>;
                          } else {
                            return (
                              <MDButton
                                className="btn-spc"
                                color="success"
                                sx={{ pointerEvents: "none" }}
                              >
                                <CircularProgress color="white" size={22} />
                              </MDButton>
                            );
                          }
                        })()}
                      </MDBox>
                      <MDBox mr={1}>
                        <MDButton
                          className="btn-spc"
                          color="success"
                          onClick={() => {
                            handleOpenCreateModal();
                            setFormErrors({});
                            setError("");
                            setSuccess(false);
                            setFailed("");
                            setErrorSandbox("");
                            setSuccessSandbox(false);
                            setFailedSandbox("");
                          }}
                        >
                          Add User
                        </MDButton>
                      </MDBox>
                    </Grid>
                  )}
                  {user_data?.customer?.roleId === 2 && (
                    <Grid
                      item
                      xs={12}
                      xl={2}
                      sx={{ justifyContent: "end", display: "flex" }}
                    >
                      <MDBox mr={1}>
                        {(() => {
                          if (
                            downloadData &&
                            ((Array.isArray(downloadData) &&
                              downloadData.length > 0) ||
                              typeof downloadData === "string")
                          ) {
                            return (
                              <CSVLink
                                data={downloadData}
                                className="white"
                                asyncOnClick={false}
                                filename={`Sandbox Requests.csv`}
                                onClick={handleCSVDownload}
                              >
                                <MDButton className="btn-spc" color="success">
                                  {!dataLoading ? (
                                    <span>Export</span>
                                  ) : (
                                    <CircularProgress color="white" size={22} />
                                  )}
                                </MDButton>
                              </CSVLink>
                            );
                          } else if (
                            Array.isArray(downloadData) &&
                            downloadData.length === 0
                          ) {
                            return <></>;
                          } else {
                            return (
                              <MDButton
                                className="btn-spc"
                                color="success"
                                sx={{ pointerEvents: "none" }}
                              >
                                <CircularProgress color="white" size={22} />
                              </MDButton>
                            );
                          }
                        })()}
                      </MDBox>
                    </Grid>
                  )}
                </Grid>

                {/* <Divider/> */}
                {/* <MDBox px={2} pt={user_data?.customer?.roleId == 4 ? 2.5 : 0}> */}
                {/* <MDTypography  sx={{fontSize: '16px'}} mr={2} mb={1}>Status </MDTypography> */}
                {/* <MDButton sx={tabStyle} onClick={()=> handleTabChange("")} variant={selectedTab == "" ? "gradient" : "outlined"} color="secondary">All</MDButton> */}
                {/* </MDBox> */}
                <MDBox
                  pt={3}
                  pb={3}
                  display="flex"
                  justifyContent="center"
                  className="padd-zero"
                >
                  {dataLoading ? (
                    <CircularProgress color="success" size={30} />
                  ) : (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      entriesPerPage={true}
                      showTotalEntries={true}
                      canSearch={true}
                      noEndBorder={false}
                      setGlobalFilterAPI={(value) => {
                        GetAllUsersWithSandbox(
                          dispatchData,
                          successAction,
                          errorAction,
                          value,
                          selectedTab,
                          selectedUserStatusTab,
                          selectedSandboxStatusTab
                        );
                      }}
                    />
                  )}
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {/* {console.log(selectedTab)} */}
        {selectedTab == 1 ? (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="responsive-modal"
          >
            <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
              <MDBox sx={style.modal}>
                <MDBox onClick={handleClose} className="close-modal-sm">
                  <CloseRounded color={darkMode ? "white" : "secondary"} />
                </MDBox>
                <MDTypography variant="h5" sx={{ textTransform: "Capitalize" }}>
                  {fullName}
                </MDTypography>
                <MDTypography variant="p" sx={{ fontSize: "14px" }} mb={4}>
                  {selectedItem?.email}
                </MDTypography>
                {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}
                {/* Users Tab */}
                <Grid container spacing={2} direction="row">
                  <Grid item xs={12} lg={6}>
                    <MDBox className="mb-3">
                      <FormControl fullWidth sx={{ height: "50px" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          variant="outlined"
                          color="success"
                          className="inputbox mb-2"
                        >
                          User Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedItem?.userStatus}
                          label="User Status"
                          onChange={(e) => {
                            if (e.target.value != "A") {
                              setStatusValue("P");
                              updateAPIStatuses("P");
                            }
                            setSelectedItem({
                              ...selectedItem,
                              userStatus: e.target.value,
                            });
                          }}
                          sx={{ height: "50px" }}
                        >
                          <MenuItem value={"A"}>Approve</MenuItem>
                          <MenuItem value={"P"}>Pending</MenuItem>
                          <MenuItem value={"R"}>In Review</MenuItem>
                          <MenuItem value={"W"}>Reject</MenuItem>
                          <MenuItem value={"I"}>Suspend</MenuItem>
                        </Select>
                      </FormControl>

                      {success && (
                        <MDTypography
                          color="success"
                          variant="subtitle1"
                          sx={{ fontSize: "12px" }}
                        >
                          Status changed successfully!
                        </MDTypography>
                      )}
                      {failed != "" && (
                        <MDTypography
                          color="error"
                          variant="subtitle1"
                          sx={{ fontSize: "12px" }}
                        >
                          {failed}
                        </MDTypography>
                      )}
                      {error && (
                        <MDTypography
                          color="error"
                          variant="subtitle1"
                          sx={{ fontSize: "12px" }}
                        >
                          {error}
                        </MDTypography>
                      )}
                    </MDBox>
                  </Grid>
                  {/* Sandbox Tab */}
                  <Grid item xs={12} lg={6}>
                    <MDBox className="mb-3">
                      {selectedItem?.myAPI &&
                        selectedItem?.myAPI.length > 0 &&
                        (selectedItem?.userStatus != "A" ? (
                          <div className="disable-field">
                            <FormControl
                              fullWidth
                              sx={{ height: "50px" }}
                              disabled
                            >
                              <InputLabel
                                id="demo-simple-select-label"
                                variant="outlined"
                                color="success"
                                className="inputbox mb-2"
                              >
                                Sandbox Status
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value="P"
                                label="Sandbox Status"
                                sx={{ height: "50px" }}
                              >
                                <MenuItem value={"P"} selected>
                                  Pending
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        ) : (
                          <FormControl fullWidth sx={{ height: "50px" }}>
                            <InputLabel
                              id="demo-simple-select-label"
                              variant="outlined"
                              color="success"
                              className="inputbox mb-2"
                            >
                              Sandbox Status
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={statusValue}
                              label="Sandbox Status"
                              onChange={(e) => {
                                setStatusValue(e.target.value);
                                updateAPIStatuses(e.target.value);
                              }}
                              sx={{ height: "50px" }}
                            >
                              <MenuItem value={"A"}>Approve</MenuItem>
                              <MenuItem value={"P"}>Pending</MenuItem>
                              <MenuItem value={"R"}>In Review</MenuItem>
                              <MenuItem value={"W"}>Reject</MenuItem>
                            </Select>
                          </FormControl>
                        ))}
                    </MDBox>
                  </Grid>
                </Grid>

                {selectedItem?.userStatus == "A" ? (
                  <>
                    <MDBox mb={2}>
                      <FormGroup className="checkbox-wrap">
                        {selectedItem?.myAPI.map((item) => (
                          <MDBox
                            className="horizontal-checkbox"
                            key={item.apiid}
                          >
                            <CustomCheckBox
                              product={item}
                              handleProductChange={(id, value) => {
                                handleCheckboxChanged(id, value);
                              }}
                            />
                          </MDBox>
                        ))}
                      </FormGroup>
                    </MDBox>
                    {/* {console.log(validateAOBox())} */}
                    {validateAOBox() && selectedItem?.userStatus == "A" ? (
                      <>
                        <MDTypography
                          sx={{ fontSize: "14px", margin: "0px 0px 20px 0px" }}
                        >
                          Account Opening API
                        </MDTypography>
                        <Grid container spacing={2} direction="row">
                          <Grid item xs={12} lg={6}>
                            <MDBox className="mb-3">
                              <MDInput
                                type="text"
                                label="Firm User Belongs To"
                                color="success"
                                variant="outlined"
                                value={firmUserBelongsTo}
                                onChange={(e) =>
                                  setFirmUserBelongsTo(e.target.value)
                                }
                                fullWidth
                                required
                                className="modal-input"
                              />
                              {aoErrors?.firmUserBelongsTo && (
                                <MDTypography
                                  sx={{ fontSize: "12px" }}
                                  color="error"
                                >
                                  Firm User Belongs To cannot be empty.
                                </MDTypography>
                              )}
                            </MDBox>
                            <MDBox className="mb-3">
                              <MDInput
                                type="text"
                                label="Correspondent Code"
                                color="success"
                                variant="outlined"
                                value={correspondentCode}
                                onChange={(e) =>
                                  setCorrespondentCode(e.target.value)
                                }
                                fullWidth
                                required
                                className="modal-input"
                              />
                              {aoErrors?.correspondentCode && (
                                <MDTypography
                                  sx={{ fontSize: "12px" }}
                                  color="error"
                                >
                                  Correspondent Code cannot be empty.
                                </MDTypography>
                              )}
                            </MDBox>
                          </Grid>
                          <Grid item xs={12} lg={6}>
                            <MDBox className="mb-3">
                              <MDInput
                                type="text"
                                label="Booth Id"
                                color="success"
                                variant="outlined"
                                value={boothId}
                                onChange={(e) => setBoothId(e.target.value)}
                                fullWidth
                                required
                                className="modal-input"
                              />
                              {aoErrors?.boothId && (
                                <MDTypography
                                  sx={{ fontSize: "12px" }}
                                  color="error"
                                >
                                  Booth Id cannot be empty.
                                </MDTypography>
                              )}
                            </MDBox>
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <div className="disable-field">
                    <MDBox mb={2}>
                      <FormControl fullWidth disabled>
                        <FormGroup className="checkbox-wrap">
                          {selectedItem?.myAPI.map((item) => (
                            <MDBox
                              className="horizontal-checkbox"
                              key={item.apiid}
                            >
                              <CustomCheckBoxs
                                product={item}
                                handleProductChange={(id, value) => {
                                  handleCheckboxChanged(id, value);
                                  setStatusValue("P");
                                  updateAPIStatuses("P");
                                }}
                              />
                            </MDBox>
                          ))}
                        </FormGroup>
                      </FormControl>
                    </MDBox>
                  </div>
                )}

                {successSandbox && (
                  <MDTypography
                    color="success"
                    variant="subtitle1"
                    sx={{ fontSize: "12px", textAlign: "center" }}
                  >
                    Status changed successfully!
                  </MDTypography>
                )}
                {failedSandbox && (
                  <MDTypography
                    color="error"
                    variant="subtitle1"
                    sx={{ fontSize: "12px", textAlign: "center" }}
                  >
                    There was an error submitted the request
                  </MDTypography>
                )}
                {errorSandbox && (
                  <MDTypography
                    color="error"
                    variant="subtitle1"
                    sx={{ fontSize: "12px", textAlign: "center" }}
                  >
                    {errorSandbox}
                  </MDTypography>
                )}
                {updateSuccess != "" &&
                  updateSuccess?.map(
                    (item) =>
                      item.status == "Success" && (
                        <MDTypography
                          color="success"
                          variant="subtitle1"
                          sx={{ fontSize: "12px", textAlign: "center" }}
                          key={item.apiid}
                        >
                          {`${item.name} -  ${item.message} `}
                        </MDTypography>
                      )
                  )}
                {showErrorMessage !== "" &&
                  showErrorMessage?.map((item) => renderMessage(item))}

                <MDBox
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <MDButton
                    className="btn-update mt-3 px-2 py-3"
                    sx={{ paddingLeft: 6.5, paddingRight: 6.5, width: "30%" }}
                    variant="gradient"
                    color="success"
                    onClick={() => {
                      handleSubmit();
                      handleSubmitSandbox();
                    }}
                    disabled={dataUpdating}
                  >
                    {dataUpdating ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      `Update Status`
                    )}
                  </MDButton>
                </MDBox>
              </MDBox>
            </div>
          </Modal>
        ) : (
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="responsive-modal"
          >
            <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
              <MDBox sx={style.noncutomer}>
                <MDBox onClick={handleClose} className="close-modal-sm">
                  <CloseRounded color={darkMode ? "white" : "secondary"} />
                </MDBox>
                <MDTypography variant="h5" sx={{ textTransform: "Capitalize" }}>
                  {fullName}
                </MDTypography>
                <MDTypography variant="p" sx={{ fontSize: "14px" }} mb={4}>
                  {selectedItem?.email}
                </MDTypography>
                {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}
                {/* Users Tab */}
                <MDBox className="mb-3">
                  <FormControl fullWidth sx={{ height: "50px" }}>
                    <InputLabel
                      id="demo-simple-select-label"
                      variant="outlined"
                      color="success"
                      className="inputbox mb-2"
                    >
                      User Status
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedItem?.userStatus}
                      label="User Status"
                      onChange={(e) => {
                        if (e.target.value != "A") {
                          setStatusValue("P");
                          updateAPIStatuses("P");
                        }
                        setSelectedItem({
                          ...selectedItem,
                          userStatus: e.target.value,
                        });
                      }}
                      sx={{ height: "50px" }}
                    >
                      <MenuItem value={"A"}>Approve</MenuItem>
                      <MenuItem value={"P"}>Pending</MenuItem>
                      <MenuItem value={"R"}>In Review</MenuItem>
                      <MenuItem value={"W"}>Reject</MenuItem>
                      <MenuItem value={"I"}>Suspend</MenuItem>
                    </Select>
                  </FormControl>

                  {success && (
                    <MDTypography
                      color="success"
                      variant="subtitle1"
                      sx={{ fontSize: "12px" }}
                    >
                      Status changed successfully!
                    </MDTypography>
                  )}
                  {failed != "" && (
                    <MDTypography
                      color="error"
                      variant="subtitle1"
                      sx={{ fontSize: "12px" }}
                    >
                      {failed}
                    </MDTypography>
                  )}
                  {error && (
                    <MDTypography
                      color="error"
                      variant="subtitle1"
                      sx={{ fontSize: "12px" }}
                    >
                      {error}
                    </MDTypography>
                  )}
                </MDBox>
                <MDBox
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <MDButton
                    className="btn-update mt-3 px-2 py-3"
                    sx={{ paddingLeft: 6.5, paddingRight: 6.5, width: "60%" }}
                    variant="gradient"
                    color="success"
                    onClick={() => {
                      handleSubmit();
                    }}
                    disabled={dataUpdating}
                  >
                    {dataUpdating ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      `Update Status`
                    )}
                  </MDButton>
                </MDBox>
              </MDBox>
            </div>
          </Modal>
        )}

        {/* Add User Modal */}
        <Modal
          open={openCreateModal}
          onClose={handleCloseCreateModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="responsive-modal"
        >
          <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
            <MDBox sx={style.createModal} className="mobile-size-modal">
              <MDBox sx={style.createModalHeader} mb={2} mt={-1}>
                <MDTypography variant="h4">Add User</MDTypography>
                <CloseRounded
                  className="close-modal-sm"
                  color={darkMode ? "white" : "secondary"}
                  onClick={() => {
                    handleCloseCreateModal();
                    clearFormFields();
                  }}
                />
              </MDBox>

              <Grid container spacing={2} direction="row">
                <Grid item xs={12} lg={6}>
                  <MDBox className="mb-3">
                    <MDInput
                      type="text"
                      label="First Name"
                      color="success"
                      variant="outlined"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      fullWidth
                      className="inputbox"
                      required
                    />
                    {formErrors?.firstname && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        First Name cannot be empty.
                      </MDTypography>
                    )}
                    {formErrors?.firstname_length && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        First Name cannot be more than 50 characters.
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox className="mb-3">
                    <MDInput
                      type="email"
                      label="Email Address"
                      color="success"
                      variant="outlined"
                      value={emailAddress}
                      onChange={(e) => setEmailAddress(e.target.value)}
                      fullWidth
                      className="inputbox"
                      required
                    />
                    {formErrors?.emailAddress && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Email Address cannot be empty.
                      </MDTypography>
                    )}
                    {formErrors?.emailAddress_regex && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Email Address is not valid.
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox className="mb-3">
                    <FormControl fullWidth sx={{ height: "20%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        variant="outlined"
                        color="success"
                        className="inputbox"
                        required
                      >
                        User Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={role}
                        label="User Type"
                        onChange={(e) => {
                          setRole(e.target.value);
                        }}
                        sx={{ height: "50px" }}
                        required
                      >
                        {roles.map((item) => {
                          return (
                            <MenuItem value={item?.id} key={item?.id}>
                              {item?.description}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {formErrors?.role && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        User Type cannot be empty.
                      </MDTypography>
                    )}
                  </MDBox>
                </Grid>
                <Grid item xs={12} lg={6} className="no-spacing">
                  <MDBox className="mb-3">
                    <MDInput
                      type="text"
                      label="Last Name"
                      color="success"
                      variant="outlined"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      fullWidth
                      className="inputbox"
                      required
                    />
                    {formErrors?.lastname && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Last Name cannot be empty.
                      </MDTypography>
                    )}
                    {formErrors?.lastname_length && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Last Name cannot be more than 50 characters.
                      </MDTypography>
                    )}
                  </MDBox>
                  <MDBox className="mb-3">
                    <CustomPasswordField
                      label="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="inputbox"
                    />
                    {formErrors?.password && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Password cannot be empty.
                      </MDTypography>
                    )}
                    {formErrors?.password_regex && (
                      <MDTypography sx={{ fontSize: "12px" }} color="error">
                        Password must be alphanumeric and at least 6 characters
                        long, including one uppercase letter and a special
                        character.
                      </MDTypography>
                    )}
                  </MDBox>

                  {role == 1 && (
                    <MDBox className="mb-3">
                      <FormControl fullWidth sx={{ height: "20%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          variant="outlined"
                          color="success"
                          className="inputbox"
                          required
                        >
                          Select API
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedAPI}
                          label="Select API"
                          onChange={(e) => {
                            setSelectedAPI(e.target.value);
                          }}
                          sx={{ height: "50px" }}
                          required
                        >
                          {products.map((item) => {
                            return (
                              <MenuItem value={item?.key} key={item.id}>
                                {item?.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      {formErrors?.role && (
                        <MDTypography sx={{ fontSize: "12px" }} color="error">
                          User Type cannot be empty.
                        </MDTypography>
                      )}
                    </MDBox>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <MDBox
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {success && (
                      <MDTypography
                        color="success"
                        variant="subtitle1"
                        sx={{ fontSize: "12px" }}
                      >
                        User is added successfully!
                      </MDTypography>
                    )}
                    {failed != "" && (
                      <MDTypography
                        color="error"
                        variant="subtitle1"
                        sx={{ fontSize: "12px" }}
                      >
                        {failed}
                      </MDTypography>
                    )}
                    {error && (
                      <MDTypography
                        color="error"
                        variant="subtitle1"
                        sx={{ fontSize: "12px" }}
                      >
                        {error}
                      </MDTypography>
                    )}
                    <MDButton
                      className="btn-update mt-2 px-2 py-2"
                      sx={{ width: "30%" }}
                      px={2}
                      variant="gradient"
                      color="success"
                      onClick={handleSubmitCreateUser}
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        `Submit`
                      )}
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          </div>
        </Modal>
        <SendEmail
          open={openEmailModal}
          handleClose={handleCloseEmailModal}
          darkMode={darkMode}
          style={style}
          selectedItem={selectedItem}
          isProduction={false}
        />
        <RecentEmail
          open={openRecentEmailModal}
          handleClose={handleCloseRecentEmailModal}
          darkMode={darkMode}
          style={style}
          selectedItem={selectedItem}
          isProduction={false}
        />
      </div>
      <Footer />
    </DashboardLayout>
  );
}
Author.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
Job.propTypes = {
  title: PropTypes.string.isRequired,
};
Products.propTypes = {
  myAPI: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      apiid: PropTypes.string.isRequired,
    })
  ).isRequired,
};
CustomCheckBox.propTypes = {
  product: PropTypes.shape({
    apiid: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleProductChange: PropTypes.func.isRequired,
};
CustomCheckBoxs.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleProductChange: PropTypes.func.isRequired,
};
CustomCheckBoxs.propTypes = {
  product: PropTypes.shape({
    apiid: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
};
export default Users;
